import { Injectable } from "@angular/core";
import { IncompleteAppInquiry } from "../../layout/applications/application-models/IncompleteAppInquiry";
import { IncompleteApp } from "../../layout/applications/application-models/IncompleteApp";
import { IncompleteApps } from "../../layout/applications/application-models/IncompleteApps";
import { HttpClient, } from "@angular/common/http";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { CompleteAppRequest } from "../../layout/applications/application-models/CompleteAppRequest";
import { MercuryApplicationNotesInq, MercuryNotesList } from "app/shared/models/MercuryApplicationNotes";

@Injectable()
export class ApplicationService {
    constructor(private http: HttpClient) { }

    //Properties
    controller: string = "api/Applications/";
    public appCompleteMessage: string = null;
    public appCompleteHeader: string = null;
    public pathBackFromContacts: string = null;
    public savedISO_ID: string = null;
    public savedMerchantApplication: any = null;
    public savedReferenceId: string = null;

    /**
     * Gets incomplete applications paged
     * @param inquiry The inquiry to get incomplete applications paged
     */
    public getIncompleteApplications(inquiry?: IncompleteAppInquiry) {
        let url = this.controller + "IncompleteApplicationsList";
        return this.http.post(url, inquiry);
    }

    /**
     * Deletes an application by referenceID
     * @param refID The referenceID to delete
     * @returns Nothing
     */
    public DeleteApp(refID: number) {
        let url = this.controller + "DeleteApplication/" + refID;
        console.log("deleting:", refID, url);
        return  this.http.get(url).toPromise();
    }

    /**
     * Gets completed applications paged
     * @param inquiry Paged inquiry to retrieve complete apps
     * @returns Completed applications list
     */
    public getCompleteApplications(inquiry?: CompleteAppRequest) {
        let url = this.controller + "GetCompleteApplicationList";
        return this.http.post(url, inquiry);
    }

        /**
     * Gets completed applications paged
     * @param inquiry Paged inquiry to retrieve complete apps
     * @returns Completed applications list
     */
    public getMercuryApplicationNotes(inquiry?: MercuryApplicationNotesInq):Observable<MercuryNotesList> {
        let url = this.controller + "notes";
        return this.http.post<MercuryNotesList>(url, inquiry);
    }


    /**
     * Gets the status of a completed application by ApplicationID
     * @param applicationID ApplicationID to get status on
     * @returns AppStatusInfo object containing Underwriter and status
     */
    public getCompleteApplicationStatusInfo(applicationID: number) {
        let url = this.controller + "GetAppStatusInfo/" + applicationID.toString();
        return this.http.get(url);
    }

    /**
     * Automatically triggers a download of the application PDF using a form
     * @param applicationID The ApplicationID to download
     */
    public getCompleteApplicationPdfContract(applicationID: number) {
        let url = this.controller + "GetPdfContract/" + applicationID.toString();
        var form = document.createElement("form");
        form.method = "get";
        form.target = "_blank";
        form.action = url;

        var div = document.getElementById("appendContractFormHere");
        div.appendChild(form);
        form.submit();

        //  return this.http.get(url);
    }
}
